import ShoppingCartItems from './ShoppingCartItems';

export default ShoppingCartItems;
